import { render, staticRenderFns } from "./HeadCenterMenu.vue?vue&type=template&id=f452c470"
import script from "./HeadCenterMenu.vue?vue&type=script&lang=js"
export * from "./HeadCenterMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports